import Vue from "vue";

import comboComponent from "@/components/child/form/combo.vue";
import decimalComponent from "@/components/child/form/decimal.vue";
import decimalComSinalCustomComponent from "@/components/child/form/decimalComSinalCustom.vue";
import moedaComponent from "@/components/child/form/moeda.vue";
import { Component, Prop } from "@/decorators";
import FracionamentoModel from "@/models/fracionamentoModel";
import ItemEmbalagemFracionamentoModel from "@/models/itemEmbalagemFracionamentoModel";

import itemEmbalagemComponent from "./itemEmbalagem.vue";

@Component({
    components: {
        comboComponent,
        moedaComponent,
        decimalComponent,
        decimalComSinalCustomComponent,
        itemEmbalagemComponent,
    },
})
export default class KitEmbalagensComponent extends Vue {
    private model = new FracionamentoModel();

    @Prop(Array) itensVenda;
    @Prop({ type: Boolean, default: false }) alteracao: boolean;
    @Prop({ type: Boolean, default: false }) desativaCampos: boolean;

    public setFracionamento(fracionamento: FracionamentoModel) {
        this.model = new FracionamentoModel();
        this.model = { ...fracionamento, itensEmbalagem: [...fracionamento.itensEmbalagem] } as FracionamentoModel;
    }

    private onChangeItem(item: ItemEmbalagemFracionamentoModel, index: number) {
        item.produtoLotePadraoId = item.produtoLoteId;
        this.model.itensEmbalagem[index] = item;
        this.$emit("change-embalagens", this.model.itensEmbalagem);
    }

    private async onRemoveItem(item: ItemEmbalagemFracionamentoModel, index: number) {
        try {
            const response = await this.$showQuestion(
                this.$t("__.ts.atencao"),
                this.$t("__.ts.desejaRemov") + item.produto.descricao + "?",
            );
            if (response) {
                this.model.itensEmbalagem.splice(index, 1);
                await this.$showSuccess(this.$t("__.ts.exclusao"), this.$t("__.ts.regisExcluSucess"));
            }
        } catch {}
    }
}
